var blocVideo = document.querySelectorAll('.admin-area .bloc__wrapper--video');
var blocVideoIframe = document.querySelectorAll('.admin-area .bloc__wrapper--iframe');
var videoIframeSrc = document.querySelectorAll('.admin-area .popup-area iframe');
var closePopupArea = document.querySelectorAll('.admin-area .popup-area .close-area-popup');

for (let i = 0; i < blocVideo.length; i++) {
    blocVideo[i].addEventListener('click', function(){
        blocVideo[i].closest('.bloc').querySelector('.popup-area').classList.add('show-popup');
    })
}

for (let i = 0; i < blocVideoIframe.length; i++) {
    blocVideoIframe[i].addEventListener('click', function () {
        if ( !videoIframeSrc[i].getAttribute('src') ) {
            videoIframeSrc[i].setAttribute('src', videoIframeSrc[i].getAttribute('data-src'));
        }
    })
}

for (let i = 0; i < closePopupArea.length; i++) {
    closePopupArea[i].addEventListener('click', function() {
        closePopupArea[i].closest('.bloc').querySelector('.popup-area').classList.remove('show-popup');

        for (let i = 0; i < blocVideoIframe.length; i++) {
            videoIframeSrc[i].removeAttribute('src');
        }
    })
}